import { Component, NgZone } from '@angular/core';
import { AuthenticationService } from "../../authentication.service";
import { FlashService } from '../../flash/flash.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ErrorService } from '../../services/error.service';
import { Router } from "@angular/router";

@Component({
  selector: 'sso-handler',
  templateUrl: './sso-handler.component.html',
  styleUrls: ['./sso-handler.component.css']
})
export class MicrosoftSsoComponent {
  constructor(
    private authenticationService: AuthenticationService,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService,
    private errorService: ErrorService,
    private ng_zone: NgZone,
    private router: Router,
  ) {}
  ngOnInit() {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const hash = url.hash;
    if(hash) {
      const idToken = hash.split('=')[1];
      let bodyData = { token: idToken };
      this.authenticationService.signInWithMicrosoft(bodyData).subscribe(
        (data) => {
          this.spinnerService.hide();
          this.ng_zone.run(() => {
            if (data.body.hasOwnProperty("success") && !data.body["success"]) {
              this.flashService.show(data.body["message"], "alert-danger");
            } else {
              this.setupSigInData(data);
            }
          });
        },
        (error) => {
          this.spinnerService.hide();
          this.flashService.show(error.error.errors[0], "alert-danger");
          this.authenticationService.changeLogin(false);
          this.errorService.errorHandling(error);
        }
      );
    }
  }

  private setupSigInData(data) {
    localStorage.setItem("access-token", data.headers.get("access-token"));
    localStorage.setItem("client", data.headers.get("client"));
    localStorage.setItem("client_id", data.body["data"].id);
    localStorage.setItem("expiry", data.headers.get("expiry"));
    localStorage.setItem("uid", data.headers.get("uid"));
    localStorage.setItem(
      "currentUser",
      JSON.stringify({
        id: data.body["data"].id,
        name: data.body["data"].name,
        email: data.body["data"].uid,
        joined_on: data.body["data"].joining_date,
        roles: data.body["data"].roles,
        owner: data.body["data"].owner,
        manager: data.body["data"].manager,
        emp_id: data.body["data"].emp_id,
        department: data.body["data"].department,
        is_timesheet_manager: data.body["data"].is_timesheet_manager,
        is_work_from_home_manager: data.body["data"].is_work_from_home_manager,
        is_blog_enabled: data.body["data"].is_blog_enabled,
        is_offboarding_enabled: data.body["data"].is_offboarding_enabled,
      })
    );
    this.authenticationService.changeLogin(true);
    this.flashService.show("Logged in successfully", "alert-success");
    this.ng_zone.run(() => {
      this.router.navigate([`/account/${data.body["data"].id}/accountGoals`]);
    });
  }
}


// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/authentication/sso-handler/sso-handler.component.ts